if (!customElements.get('pr-pain-solution')) {
  customElements.define('pr-pain-solution', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.querySelectorAll('details').forEach(item => {
        const summary = item.querySelector('summary');
        const answer = item.querySelector('.prps-answer');
        summary.addEventListener('click', event => {
          if (matchMedia('(prefers-reduced-motion: reduce)').matches || !answer.animate) return;
          event.preventDefault();
          if (item.dataset.animating) return;
          const closing = item.open;
          item.open = true;
          item.dataset.animating = 'true';
          const height = answer.scrollHeight;
          const animation = answer.animate([{height: closing ? `${height}px` : '0px', opacity: closing ? 1 : 0},{height: closing ? '0px' : `${height}px`, opacity: closing ? 0 : 1}], {duration:240,easing:'ease-out'});
          animation.onfinish = () => { item.open = !closing; delete item.dataset.animating; };
        }, {signal:this.controller.signal});
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
  });
}
